<template>
  <TopPanel>
    <BreadCrumbs :items="items" class="s-bread" />
    <div class="button-container">
      <Button
        label="Отправить в рекламный кабинет"
        class="save-button m-l-16 m-r-16"
        @click="createCampaign"
        :disabled="isButtonDisabled"
        :loading="isLoading"
      />
    </div>
  </TopPanel>
</template>

<script setup lang="ts">
import { ref } from "vue";

import BreadCrumbs from "@/shared/menu/BreadCrumbs.vue";
import Button from "primevue/button";
import TopPanel from "@/widgets/sidebars/TopPanel.vue";

defineProps<{
  isLoading: boolean;
  isButtonDisabled?: boolean;
}>();

const emit = defineEmits(["createCampaign"]);

const items = ref([
  { label: "Кампании", route: "listCampaigns" },
  { label: "Запуск кампании" },
]);

const createCampaign = () => {
  emit("createCampaign");
};
</script>

<style lang="scss" scoped>
.s-bread {
  margin-left: 18px;
}

.button-container {
  flex: 1;

  display: flex;
  justify-content: end;

  margin: 0 20px;
}

.save-button {
  min-width: 270px;
}
</style>
